import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getFormMetaController } from '../../selectors/formSelector';
import ltAnalytics from '../../utils/ltAnalyticsService';
import * as eventnames from '../../common/trackingeventnames';

const EditButton = (props) => {
  const formMeta = useSelector(getFormMetaController);

  const handleClick = (e) => {
    if (formMeta) {
      ltAnalytics(eventnames.SUMMARY_EDIT_CLICKED, {
        ...formMeta,
      });
    }
    if (props.action) props.action(e);
  };

  return (
    <button id="ltEditButton" onClick={handleClick}>
      {props.label}
    </button>
  );
};

EditButton.propTypes = {
  action: PropTypes.func,
  label: PropTypes.string,
};

export default EditButton;
